<div class="wrapper">
  <h2>Explore shared projects</h2>
  <div class="filter-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Search projects</mat-label>
      <input matInput [formControl]="searchControl" placeholder="Filter by name or topic">
      @if (searchControl.value) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="searchControl.reset()">
          <mat-icon>close</mat-icon>
        </button>
      }
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>
  @if (filteredProjects(); as projects) {
    <div class="project-list">
      @for (project of projects; track project.id) {
        <app-explore-project-card [project]="project"></app-explore-project-card>
      }
    </div>
  }
</div>
<app-footer></app-footer>
